@if (!simplified()) {
  <label class="soft-label top" [class.required]="required()" for="vehicle"
    >{{ label() }}
    @if (!required()) {
      <span class="text-gray-300">(optional)</span>
    }
  </label>
}
<div class="relative w-full" (softClickOutside)="searchFocused.set(false)">
  <div
    class="rounded-md flex items-center border font-[1rem] bg-surface px-2 py-1 gap-2"
    [class]="
      searchFocused() && !loading()
        ? 'border-black'
        : selectedObject()
          ? 'border-success'
          : loading() && _value()
            ? 'border-black animate-pulse'
            : 'border-gray-300'
    "
  >
    @if (loading() && _value()) {
      <i class="fa-regular fa-spinner fa-spin"></i>
    } @else {
      <i
        [class]="
          searchFocused()
            ? 'fa-regular fa-magnifying-glass text-black'
            : selectedObject()
              ? icon() + ' text-success'
              : 'fa-regular fa-magnifying-glass text-gray-400'
        "
      ></i>
    }
    @if (selectedObject()) {
      <soft-chip>
        <ng-container
          *ngTemplateOutlet="resultTemplate(); context: { $implicit: selectedObject() }"
        ></ng-container>
        <i
          class="fa-regular fa-xmark ml-1 cursor-pointer"
          (click)="selectedObject.set(null); _value.set(null); setFocused()"
        ></i>
      </soft-chip>
    } @else {
      <input
        [value]="_value()"
        (input)="onInputChange($event.target.value)"
        (focus)="searchFocused.set(true)"
        [placeholder]="placeholder()"
        #inputElement
      />
      @if (_value()) {
        <i
          (click)="setInputValue(null); setFocused(); search()"
          class="fa-regular fa-xmark cursor-pointer text-black"
        ></i>
      } @else if (!simplified()) {
        <i
          (click)="openAdvancedSearch()"
          class="fa-regular fa-database cursor-pointer text-gray-400 hover:text-black"
        ></i>
      }
    }
  </div>
  @if (searchFocused() && simplified() && sortedLastSearchResults().length > 0) {
    <div class="flex gap-1 items-center mt-1">
      <p class="text-black text-xs">Letzte Suchanfragen:</p>
      @for (e of sortedLastSearchResults(); track e.key) {
        <soft-chip
          (click)="_value.set(e.body.text); search()"
          class="cursor-pointer text-light"
        >
          <i class="fa-regular fa-clock"></i>
          {{ e.body.text }}
          <i
            class="fa-regular fa-xmark ml-1 text-black"
            (click)="deleteLastSearchResult(e.key); $event.stopPropagation()"
          ></i>
        </soft-chip>
      }
    </div>
  }
  @if (searchFocused() && !simplified()) {
    <div
      class="flex flex-col border border-black rounded-md absolute !z-20 bg-surface mt-1 right-0 left-0 overflow-hidden text-sm"
    >
      @if (!_value()) {
        @if (sortedLastSearchResults().length > 0) {
          <div class="flex justify-between bg-[#E8E8E8] px-2 border-b border-black">
            <p class="text-black">Letzte Suchanfragen</p>
            <button
              class="text-primary cursor-pointer"
              (click)="deleteAllLastSearchResults()"
            >
              Alle löschen
            </button>
          </div>
          <div class="max-h-60 overflow-y-auto gap-1 border-b border-black">
            @for (e of sortedLastSearchResults(); track e.key) {
              <div
                class="justify-between flex cursor-pointer hover:bg-hover px-2 items-center border-b"
                (click)="_value.set(e.body.text); search()"
              >
                <p><i class="fa-regular fa-clock mr-2 mt-1"></i>{{ e.body.text }}</p>
                <p class="text-light">{{ e.createdAt | date: 'short' }}</p>
              </div>
            }
          </div>
        }
        @if (sortedLastUsedEntities().length > 0) {
          <div class="flex justify-between bg-[#E8E8E8] px-2 border-black border-b">
            <p class="text-black">Zuletzt verwendete Einträge</p>
          </div>
          <div class="max-h-60 overflow-y-auto gap-1 border-b border-black">
            @for (e of sortedLastUsedEntities(); track e.key) {
              <div
                class="justify-between flex cursor-pointer hover:bg-hover px-2 items-center border-b"
                (click)="selectedObject.set(e); searchFocused.set(false); setLastUsed(e)"
              >
                <div class="flex items-center gap-1">
                  <i class="fa-regular mr-1" [class]="icon()"></i>
                  <ng-container
                    *ngTemplateOutlet="resultTemplate(); context: { $implicit: e }"
                  ></ng-container>
                </div>
                <div>
                  <p class="text-light">{{ e.createdAt | date: 'short' }}</p>
                  <i
                    (click)="setFavorite(e); $event.stopPropagation()"
                    [class]="
                      favoriteEntities().includes(e)
                        ? 'fa-solid text-warning'
                        : 'fa-regular '
                    "
                    class="fa-regular mr-1 fa-star hover:fa-regular hover:text-warning"
                  ></i>
                </div>
              </div>
            }
          </div>
        }
        @if (favoriteEntities().length > 0) {
          <div class="flex justify-between bg-[#E8E8E8] px-2 border-black border-b">
            <p class="text-black">Favoriten</p>
          </div>
          <div class="max-h-60 overflow-y-auto gap-1 border-b border-black">
            @for (e of favoriteEntities(); track e.key) {
              <div
                class="justify-between flex cursor-pointer hover:bg-hover px-2 items-center border-b"
                (click)="selectedObject.set(e); searchFocused.set(false); setLastUsed(e)"
              >
                <div class="flex items-center gap-1">
                  <i class="fa-regular mr-1" [class]="icon()"></i>
                  <ng-container
                    *ngTemplateOutlet="resultTemplate(); context: { $implicit: e }"
                  ></ng-container>
                </div>
                <div>
                  <p class="text-light">{{ e.createdAt | date: 'short' }}</p>
                  <i
                    (click)="setFavorite(e); $event.stopPropagation()"
                    [class]="
                      favoriteEntities().includes(e)
                        ? 'fa-solid text-warning'
                        : 'fa-regular '
                    "
                    class="fa-regular mr-1 fa-star hover:fa-regular hover:text-warning"
                  ></i>
                </div>
              </div>
            }
          </div>
        }
      } @else if (searching()) {
        <div class="flex justify-between bg-[#E8E8E8] px-2 border-black border-b">
          <p class="text-black">Suche...</p>
        </div>
        <div class="max-h-60 overflow-y-auto gap-1 border-b border-black animate-pulse">
          <div class="justify-between flex px-2 items-center border-b" *softRepeat="3">
            <div class="flex items-center gap-1">
              <div class="h-8 bg-gray-300 rounded w-8">&nbsp;</div>
              <div class="w-full h-[44px] flex flex-col justify-center">
                <div class="h-2 bg-gray-300 rounded w-32">&nbsp;</div>
                <div class="h-2 bg-gray-300 rounded w-40 mt-1">&nbsp;</div>
              </div>
            </div>
          </div>
        </div>
      } @else if (searchResults()?.length === 0) {
        <div class="flex flex-col justify-center p-2 border-black border-b items-center">
          <soft-icon class="text-light fa-2x" [name]="'fa-inbox fa-regular'"></soft-icon>
          <span class="font-semibold">Keine Ergebnisse gefunden</span>
          <span class="text-xs">
            Es wurden keine Ergebnisse gefunden, die den Suchkriterien entsprechen.
          </span>
        </div>
      }
      @if (
        (searchResults()?.length ?? 0) > 0 &&
        !loading() &&
        !searching() &&
        ((searched() && _value()) || suggestions())
      ) {
        <div class="flex justify-between bg-[#E8E8E8] px-2 border-black border-b">
          <p class="text-black">
            {{ searchResults()?.length }}
            {{
              searched() && _value()
                ? searchResults()?.length === 1
                  ? 'Ergebnis'
                  : 'Ergebnisse'
                : searchResults()?.length === 1
                  ? 'Vorschlag'
                  : 'Vorschläge '
            }}
            gefunden
          </p>
        </div>
        <div class="max-h-60 overflow-y-auto gap-1 border-b border-black">
          @for (result of searchResults() || []; track result.id) {
            <div
              class="justify-between flex cursor-pointer hover:bg-hover px-2 items-center border-b"
              (click)="
                selectedObject.set(result); searchFocused.set(false); setLastUsed(result)
              "
            >
              <div class="flex items-center gap-1">
                <i class="fa-regular mr-1" [class]="icon()"></i>
                <ng-container
                  *ngTemplateOutlet="resultTemplate(); context: { $implicit: result }"
                ></ng-container>
              </div>
              <div class="flex">
                <p class="text-light">{{ result.createdAt | date: 'short' }}</p>
                <i
                  (click)="setFavorite(result); $event.stopPropagation()"
                  [class]="
                    favoriteEntities().includes(result)
                      ? 'fa-solid text-warning'
                      : 'fa-regular '
                  "
                  class="fa-regular mr-1 fa-star hover:fa-regular hover:text-warning"
                ></i>
              </div>
            </div>
          }
        </div>
      }

      <div class="flex justify-between bg-[#E8E8E8] px-2 py-1 text-black">
        <div class="flex gap-1">
          <div class="flex gap-1 items-center">
            <div class="border border-black rounded-md px-1">esc</div>
            Schließen
          </div>
          <div class="flex gap-1 items-center">
            <div class="border border-black rounded-md px-1">
              <i class="fa-regular fa-arrow-up"></i>
            </div>
            <div class="border border-black rounded-md px-1">
              <i class="fa-regular fa-arrow-down"></i>
            </div>
            Auswählen
          </div>
          <div class="flex gap-1 items-center">
            <div class="border border-black rounded-md px-1">enter</div>
            Auswählen
          </div>
        </div>
        <div class="flex gap-1 items-center">
          <div class="border border-black rounded-md px-1">F4</div>
          Erweiterte Suche
        </div>
      </div>
    </div>
  }
</div>
